// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1OVdE","imageUploader":"EGiftCard_imageUploader__2H0C9"};